import React from 'react';
import { useTranslate } from '../../../components/TranslationText';
import EahsForm from '../../../components/EahsForm';
import { FormRadio } from '../../../components/FormInputs';
import { SemenStallionType } from '../constants/semenStallionType';

/**
 * Semen Types selection section.
 *
 * @param {boolean} disabled - Disable the radio buttons (view-only mode)
 */
export default function SemenTypes({ disabled = false }) {
    const { translate } = useTranslate();

    return (
        <EahsForm title={<>{translate('web.semenType', 'Semen Type')} <span className="color-eahsred">*</span></>}>
            <div className="row px-3">
                <FormRadio
                    name="semenType"
                    label=""
                    options={[
                        { text: translate('web.fresh', 'Fresh'), value: SemenStallionType.Fresh },
                        { text: translate('web.frozen', 'Frozen'), value: SemenStallionType.Frozen },
                        // { text: translate('web.liveFoal', 'Live Foal'), value: SemenStallionType.LiveFoal },
                    ]}
                    required
                    disabled={disabled}
                />
            </div>
        </EahsForm>
    );
}
